import React, { FC } from 'react'
import Container from 'react-bootstrap/Container'
import useEnvironment from '../../hooks/location/useEnviroment'
import PageTitle from '../../components/PageTitle'

import {
  preferedName,
} from '../../assets/i18n/i18n'
import { Link } from 'react-router-dom'

const Developer: FC = () => {
  const { data: environment } = useEnvironment()
  const patientEndpoint = environment?.patientAccessEndpointURL
  const providerEndpoint = environment?.providerDirectoryEndpointURL

  const patientDocs = environment?.patientAccessDocumentationURL
  const providerDocs = environment?.providerDirectoryDocumentationURL

  return (
    <section className='content'>
      <Container>
        <PageTitle displayName='Developer API Information' />
        <h1 className='headerText h2'>{preferedName} APIs</h1>

        <p>The {preferedName} APIs are standards-based <a href="https://www.hl7.org/fhir/http.html" target="_blank" rel="noreferrer">RESTful APIs</a> that conform to <a href="http://hl7.org/fhir/R4/" target="_blank" rel="noreferrer">HL7 FHIR R4</a>, <a href="https://hl7.org/fhir/smart-app-launch/1.0.0/" target="_blank" rel="noreferrer">SMART on FHIR</a>, and <a href="https://openid.net/specs/openid-connect-core-1_0.html" target="_blank" rel="noreferrer">OpenID Connect</a> standards.</p>

        <hr></hr>

        <h2 className='fw-bold h3'>Patient Access API</h2>

        <h3 className='fw-bold h5'>Endpoint URL</h3>

        <p>
          {patientEndpoint}
        </p>

        <h3 className='fw-bold h5'>
          {patientDocs ? 'Capability Statement and Testing' : 'Capability Statement'}
        </h3>

        <ul>
          {patientDocs && (
            <li>
              <a href={`${patientDocs}`} target="_blank" rel="noreferrer">
                API Syntax documentation using Swagger
              </a>
            </li>
          )}

          <li>
            <a href={`${patientEndpoint}/metadata`} target="_blank" rel="noreferrer">
              API Capability Statement
            </a>
          </li>
        </ul>

        <h3 className='fw-bold h5'>Process for Requesting Access to Patient Access API</h3>

        <p>The process for a third party developer to request access is as follows:</p>

        <ol>
          <li><Link to="/app-register">Register your application</Link></li>
          <li>You will be contacted by a member of our team to coordinate access to our DEMO portal for testing and verification.</li>
          <li>If approved for production access, a member of our team will work with you to get the necessary production keys and access.</li>
        </ol>

        <h3 className='fw-bold h5'>
          <Link to="/app-register">App Developer Patient Access API Registration</Link>
        </h3>
        <hr></hr>

        <h2 className='fw-bold h3'>Provider Directory API</h2>

        <h3 className='fw-bold h5'>Endpoint URL</h3>

        <p>{`${providerEndpoint}`}</p>
        <h3 className='fw-bold h5'>
          {providerDocs ? 'Capability Statement and Testing' : 'Capability Statement'}
        </h3>

        <ul>
          {providerDocs && (
            <li>
              <a href={`${providerDocs}`} target="_blank" rel="noreferrer">
                API Syntax documentation using Swagger
              </a>
            </li>
          )}

          <li>
            <a href={`${providerEndpoint}/metadata`} target="_blank" rel="noreferrer">
              API Capability Statement
            </a>
          </li>
        </ul>
        <h3 className='fw-bold h5'>Process for Requesting Access to Provider Directory API</h3>

        <p>To support open directories, the Provider Directory API is implemented by design on an endpoint that does not require authentication or registration. </p>

      </Container>
    </section>
  )
}

export default Developer